export default __webpack_public_path__ + "static/media/document.56b5708e.svg";